import { PreloadedQuery, usePreloadedQuery, useQueryLoader } from "react-relay"
import { chAuditQuery as chAuditQueryType } from "@/modules/patients/history/services/ch/__generated__/chAuditQuery.graphql"
import { chAuditQuery } from "@/modules/patients/history/services/ch/chAuditQuery"
import { deAuditQuery as deAuditQueryType } from "@/modules/patients/history/services/de/__generated__/deAuditQuery.graphql"
import { deAuditQuery } from "@/modules/patients/history/services/de/deAuditQuery"
import { Country } from "@/types/__generated__/union-types"

export type AuditEventsQueryType = chAuditQueryType & deAuditQueryType

export const useAuditEventsQuery = (countryCode: Country) => {
  const [queryRef, loadQuery] = useQueryLoader<AuditEventsQueryType>(countryCode === "CH" ? chAuditQuery : deAuditQuery)

  return { queryRef, loadQuery }
}

export const useAuditEventsPreloadQuery = (countryCode: Country, queryRef: PreloadedQuery<AuditEventsQueryType>) => {
  return usePreloadedQuery<AuditEventsQueryType>(countryCode === "CH" ? chAuditQuery : deAuditQuery, queryRef)
}
